import Link from 'next/link';
import React from 'react';
import { Logo } from '../../Logo';
import { getActiveLocale } from '@/utils/active-locale';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LogoLink = ({ mobileNavigationHandler }: { mobileNavigationHandler: React.Dispatch<React.SetStateAction<any>> }) => {
  const activeLocale = getActiveLocale();
  return (
    <div className='flex items-center justify-between'>
      <Link href={`/${activeLocale}`} className='-m-1.5 p-1.5 mt-2.5 px-4' onClick={mobileNavigationHandler}>
        <span className='sr-only'>Your Company</span>
        <Logo />
      </Link>
    </div>
  );
};
